import { Component, Input, forwardRef, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
	selector: 'bb-text',
	templateUrl: './bb-text.component.html',
	styleUrls: ['./bb-text.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbTextComponent),
		multi: true
	}]

})

export class BbTextComponent implements ControlValueAccessor, OnInit, OnChanges {

	@Input() disabled = false;
	@Input() placeholder = '';
	@Input() value: string;

	propagateChange: any;

	constructor() { }

	ngOnInit() {
		if (this.disabled === undefined) {
			this.disabled = false;
		}
	}

	ngOnChanges(changes: SimpleChanges) { }

	writeValue(value: string) {
		this.value = value;
	}

	valueChanged() {
		if (this.propagateChange) {
			this.propagateChange(this.value);
		}
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() { }
}
